<template>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <aside class="widget card widget--sidebar widget-standings">
          <div class="widget__title card__header card__header--has-btn">
            <h4>Trophies</h4>
            <router-link :to="`/players`" class="btn btn-default btn-xs card-header__button">See All Stats</router-link>
          </div>
          <div class="widget__content card__content">
            <div class="table-responsive">
              <table class="table table-hover table-standings">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Character</th>
                    <th>Trophies</th>
                  </tr>
                </thead>
                <tbody v-if="player_trophies.length">
                  <tr v-for="(p, idx) in player_trophies" :key="idx">
                    <td>
                      <div class="team-meta">
                      </div>
                    </td>
                    <td>
                      <div class="team-meta">
                        <figure class="team-meta__logo">
                          <img v-if="p.clan" v-lazy="p.clan.badge" :alt="p.clan.name" width="35" height="35" />
                        </figure>
                        <div class="team-meta__info">
                          <h6 class="team-meta__name">
                            <router-link :to="`/players/${p.tag.replaceAll('#', '')}`">
                              {{ p.name }}
                            </router-link>
                          </h6>
                          <span class="team-meta__place" v-if="p.clan">
                            <i v-if="p.clan">{{ p.clan.name }}</i>&nbsp;
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{{ p.characterId }}</td>
                    <td>{{ p.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </aside>
        <!-- Widget: Standings / End -->
      </div>
      <div class="col-lg-6">
        <!-- Widget: Standings -->
        <aside class="widget card widget--sidebar widget-standings">
          <div class="widget__title card__header card__header--has-btn">
            <h4>Versus Trophies</h4>
            <router-link :to="`/players`" class="btn btn-default btn-xs card-header__button">See All Stats</router-link>
          </div>
          <div class="widget__content card__content">
            <div class="table-responsive">
              <table class="table table-hover table-standings">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Character</th>
                    <th>Trophies</th>
                  </tr>
                </thead>
                <tbody v-if="player_versus.length">
                  <tr v-for="(p, idx) in player_versus" :key="idx">
                    <td>
                      <div class="team-meta">
                      </div>
                    </td>
                    <td>
                      <div class="team-meta">
                        <figure class="team-meta__logo">
                          <img v-if="p.clan" v-lazy="p.clan.badge" :alt="p.clan.name" width="35" height="35" />
                        </figure>
                        <div class="team-meta__info">
                          <h6 class="team-meta__name">
                            <router-link :to="`/players/${p.tag.replaceAll('#', '')}`">
                              {{ p.name }}
                            </router-link>
                          </h6>
                          <span class="team-meta__place">
                            <i v-if="p.clan">{{ p.clan.name }}</i>&nbsp;
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{{ p.characterId }}</td>
                    <td>{{ p.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </aside>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="card card--has-table">
          <div class="card__header card__header--has-btn">
            <h4>Trophies</h4>
            <router-link :to="`/clans`" class="btn btn-default btn-xs card-header__button">Clans Rankings</router-link>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table class="table table-hover team-schedule">
                <thead>
                  <tr>
                    <th class="team-schedule__date">Rank</th>
                    <th class="team-schedule__date">Previous Rank</th>
                    <th class="team-schedule__versus">Name</th>
                    <th class="team-schedule__time">Level</th>
                    <th class="team-schedule__league">Members</th>
                    <th class="team-schedule__tickets">Points</th>
                  </tr>
                </thead>
                <tbody v-if="clan_trophies.length">
                  <tr v-for="(c, idx) in clan_trophies" :key="idx">
                    <td class="team-schedule__date">{{ c.rank }}</td>
                    <td class="team-schedule__date">{{ c.previousRank }}</td>
                    <td class="team-schedule__versus">
                      <div class="team-meta">
                        <figure class="team-meta__logo">
                          <img v-lazy="c.badgeUrls.small" :alt="c.name" width="35" height="35" />
                        </figure>
                        <div class="team-meta__info">
                          <h6 class="team-meta__name">
                            <router-link :to="`/clans/${c.tag.replaceAll('#', '')}`">{{ c.name }}</router-link>
                          </h6>
                          <span class="team-meta__place" v-if="c.otherRanking">
                            {{ c.otherRanking.locationId }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="team-schedule__time">{{ c.clanLevel }}</td>
                    <td class="team-schedule__league">{{ c.members }}</td>
                    <td class="team-schedule__tickets">{{ c.clanPoints }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card--has-table">
          <div class="card__header card__header--has-btn">
            <h4>Versus Trophies</h4>
            <router-link :to="`/clans`" class="btn btn-default btn-xs card-header__button">Clans Rankings</router-link>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table class="table table-hover team-schedule">
                <thead>
                  <tr>
                    <th class="team-schedule__date">Rank</th>
                    <th class="team-schedule__date">Previous Rank</th>
                    <th class="team-schedule__versus">Name</th>
                    <th class="team-schedule__time">Level</th>
                    <th class="team-schedule__league">Members</th>
                    <th class="team-schedule__tickets">Points</th>
                  </tr>
                </thead>
                <tbody v-if="clan_versus_trophies.length">
                  <tr v-for="(c, idx) in clan_versus_trophies" :key="idx">
                    <td class="team-schedule__date">{{ c.rank }}</td>
                    <td class="team-schedule__date">{{ c.previousRank }}</td>
                    <td class="team-schedule__versus">
                      <div class="team-meta">
                        <figure class="team-meta__logo">
                          <img v-lazy="c.badgeUrls.small" :alt="c.name" width="35" height="35" />
                        </figure>
                        <div class="team-meta__info">
                          <h6 class="team-meta__name">
                            <router-link :to="`/clans/${c.tag.replaceAll('#', '')}`">{{ c.name }}</router-link>
                          </h6>
                          <span class="team-meta__place" v-if="c.otherRanking">
                            {{ c.otherRanking.locationId }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="team-schedule__time">{{ c.clanLevel }}</td>
                    <td class="team-schedule__league">{{ c.members }}</td>
                    <td class="team-schedule__tickets">{{ c.clanVersusPoints }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import Common from "../../common/common"
  import axios from "axios"

  export default {
    name: "Home",
    props: {},
    mixins: [Common],
    data() {
      return {
        clan_trophies: [],
        clan_versus_trophies: [],
        player_trophies: [],
        player_versus: [],
        locationId: ``,
      };
    },
    methods: {
      getRankings() {
        axios.get(`${this.root}/rankings?locationId=global&limit=9`).then(({
          data
        }) => {
          this.clan_trophies = data.clan_trophies || []
          this.clan_versus_trophies = data.clan_versus || []
          this.player_trophies = data.player_trophies || []
          this.player_versus = data.player_versus || []
        }).catch(({
          response
        }) => {
          console.log(response)
        })
      },
    },
    mounted() {
      this.getRankings()
    },
  };
</script>
<style>
  .table>tbody>tr>td {
    font-size: 13px;
  }
  .text-uppercase {
    text-transform: uppercase;
  }
</style>